export const CCN_MISSING = 'Credit card number is missing';
export const CCN_INVALID = 'This does not appear to be a valid credit card';
const MASK_CHARACTER = 'X';
const GAP_CHARACTER = '-';
export const sanitizeCreditCardNumber = ccNumber => ccNumber.replace(/\D+/g, '').trim();
export const isValidCCNLength = (cardType, ccNumber) => {
  const ccNumberLength = ccNumber.length;
  return ccNumberLength !== 0 && cardType.lengths.filter(len => ccNumberLength === len).length > 0;
};
export const validateCreditCardNumber = (cardType, ccNumber) => {
  const sanitizedCreditCardNumber = sanitizeCreditCardNumber(ccNumber);
  const ccNumberLength = sanitizedCreditCardNumber.length;
  if (ccNumberLength === 0) {
    return CCN_MISSING;
  }
  if (cardType.type === 'generic' || !isValidCCNLength(cardType, sanitizedCreditCardNumber)) {
    return CCN_INVALID;
  }
  return undefined;
};
export const processCreditCardNumber = (paymentCardType, ccNumber, showMasked) => {
  const strippedPaymentInformation = sanitizeCreditCardNumber(ccNumber);
  let maskedCardNumber = strippedPaymentInformation;
  let cc = strippedPaymentInformation;
  if (paymentCardType && strippedPaymentInformation.length > 0) {
    const asterisks = MASK_CHARACTER.repeat(strippedPaymentInformation.length);
    const maskedCardDigits = asterisks.split('');
    const cardDigits = strippedPaymentInformation.split('');
    const gapsRightToLeft = [...paymentCardType.gaps].reverse();
    gapsRightToLeft === null || gapsRightToLeft === void 0 || gapsRightToLeft.forEach(gapIndex => {
      if (gapIndex < strippedPaymentInformation.length) {
        maskedCardDigits.splice(gapIndex, 0, GAP_CHARACTER);
        cardDigits.splice(gapIndex, 0, GAP_CHARACTER);
      }
    });
    maskedCardNumber = maskedCardDigits.join('');
    cc = cardDigits.join('');
  }
  return {
    maskedCardNumber,
    cardNumber: strippedPaymentInformation,
    creditCardFieldValue: showMasked ? maskedCardNumber : cc,
    errorMessage: validateCreditCardNumber(paymentCardType, strippedPaymentInformation)
  };
};